import React from 'react';
import { Nav, Sidenav, Sidebar } from 'rsuite';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import NavToggle from './NavToggle';

const StyledSidenav = styled(Sidenav)`
  padding-left: 20px;
  .rs-dropdown .rs-dropdown-toggle > .rs-icon {
    top: 12px;
  }
  .rs-nav-item .rs-nav-item-content {
    white-space: nowrap;
  }
`;

const SidebarNav = ({ children, onToggle, expanded, ...props }) => {
  const sidebarWidth = expanded ? 240 : 76;
  return (
    <Sidebar width={sidebarWidth}>
      <StyledSidenav expanded={expanded} {...props}>
        <Sidenav.Body>
          <Nav>{children}</Nav>
        </Sidenav.Body>
      </StyledSidenav>
      <NavToggle expand={expanded} onChange={onToggle} />
    </Sidebar>
  );
};

SidebarNav.propTypes = {
  children: PropTypes.node.isRequired,
  onToggle: PropTypes.func.isRequired,
  activeKey: PropTypes.string,
  expanded: PropTypes.bool
};

SidebarNav.defaultProps = {
  expanded: true,
  activeKey: ''
};

export default SidebarNav;
